module.exports = __webpack_public_path__ + "static/media/dislikeRed.c198a5da.svg";